/**
 * Shared open-overlay stack (modals + drawers + popovers) — Escape / outside
 * dismiss only closes the top-most overlay, regardless of listener order.
 */
const stack: object[] = [];

export function pushOverlay(): object {
  const id = {};
  stack.push(id);
  return id;
}

export function popOverlay(id: object): void {
  const idx = stack.indexOf(id);
  if (idx !== -1) stack.splice(idx, 1);
}

export function isTopOverlay(id: object): boolean {
  return stack[stack.length - 1] === id;
}
